import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const DefaultComponent = (props) => {
  const { history } = props;
  const { hash } = window.location;
  const hashSplit = hash.split('-');

  const url = `/${hashSplit[hashSplit.length - 1]}`;

  window.addEventListener('viAddinPageFocus', () => {
    const addinHash = window.location.hash;
    const addinHashSplit = addinHash.split('-');
    const addinUrl = `/${addinHashSplit[addinHashSplit.length - 1]}`;
    history.push(addinUrl);
  });

  const urlMatch = history.entries.filter((item) => item.pathname === url);
  if (urlMatch.length === 1) {
    history.push(url);
  }

  const isUrlUnknown = urlMatch.length === 0 || url === '/';

  return <div>{isUrlUnknown && <Redirect to="/library" />}</div>;
};

DefaultComponent.propTypes = {
  history: PropTypes.shape({
    entries: PropTypes.arrayOf(PropTypes.string).isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(DefaultComponent);
